// extracted by mini-css-extract-plugin
export default {"fhirViewerModal":"GenericFHIRViewerModal_fhirViewerModal__ekyOk","sectionHeader":"GenericFHIRViewerModal_sectionHeader__ErPLW"};